const STATUS_OK = 200;
const STATUS_CREATED = 201;
const STATUS_BAD_REQUEST = 400;
const STATUS_UNAUTHORIZED = 401;
const STATUS_RESOURCE_NOT_FOUND = 404;
const STATUS_ERROR = 500;
const STATUS_SERVICE_UNAVAILABLE = 503;
const STATUS_BAD_GATEWAY = 502;
const SECURE_WEBSITE_PROTOCOL_PREFIX = 'https://';
const UNSECURE_WEBSITE_PROTOCOL_PREFIX = 'http://';
const WWW_PREFIX = 'www';
const STAGE_PREFIX = 'stage';
const DEV_PREFIX = 'dev';
const MIDDLEWARE_PORT = 8181;
const EXPONDO_MIDDLEWARE_PORT = 4000;
const MAIN_APP_PORT = 3000;
const CT_BASE = 'newCt/';
export { CT_BASE };
export { STATUS_OK };
export { STATUS_CREATED };
export { STATUS_BAD_REQUEST };
export { STATUS_UNAUTHORIZED };
export { STATUS_ERROR };
export { STATUS_SERVICE_UNAVAILABLE };
export { STATUS_RESOURCE_NOT_FOUND };
export { STATUS_BAD_GATEWAY };
export { SECURE_WEBSITE_PROTOCOL_PREFIX };
export { UNSECURE_WEBSITE_PROTOCOL_PREFIX };
export { WWW_PREFIX };
export { STAGE_PREFIX };
export { DEV_PREFIX };
export { MIDDLEWARE_PORT };
export { EXPONDO_MIDDLEWARE_PORT };
export { MAIN_APP_PORT };
